/**
 * One rail section: the full known option list.
 *
 * Three rules, all learned the hard way:
 *
 *   1. Render every known option. Hiding a zero-count option makes a filter look
 *      like it does not exist, and the list jumps around as counts change.
 *   2. Disable a zero-count option, UNLESS it is currently selected. Removing
 *      the ground under a live selection leaves a filter that cannot be cleared
 *      from its own control.
 *   3. Don't print the count beside each option. One live total belongs on the
 *      page — the result bar above the table — and repeating a per-option
 *      breakdown inside every open dropdown only competed with it. `count` is
 *      still read, to grey out (rule 2) a value the current search can't return.
 */
export function FacetList({ items }) {
  return (
    <>
      {items.map(({ value, label, count, selected, onToggle }) => {
        const off = count === 0 && !selected;
        return (
          <label
            key={value}
            className={`opt${off ? ' off' : ''}${selected ? ' sel' : ''}`}
          >
            <input
              type="checkbox"
              checked={selected}
              disabled={off}
              onChange={onToggle}
            />
            {/* The rail is 252px, so a long label ellipsises. `title` is how the
                full text stays reachable - "English waiver (MOI / school marks)"
                is otherwise unreadable at that width. */}
            <span className="nm" title={label ?? value}>{label ?? value}</span>
          </label>
        );
      })}
    </>
  );
}
